import React from 'react'
import { Button, Card, Col, Form, Row, Spinner } from 'react-bootstrap';
import { useForm } from 'react-hook-form'

const IncidentUpdateForm = ({ currentStatus, currentAction, onUpdate, submitting}) => {
    const {register, handleSubmit, reset, formState: {errors}} = useForm({
        defaultValues: {
            status: currentStatus || 'pending',
            action_taken: currentAction || ''
        }
    });

    // Add this to update the form when incident data arrives
    React.useEffect(() => {
        reset({
            status: currentStatus,
            action_taken: currentAction
        });
    }, [currentStatus, currentAction, reset]);
    
  return (
    <Card className='border-0 shadow-sm mt-4 border-top border-4 border-primary'>
        <Card.Body className='p-4'>
            <h5 className="fw-bold mb-3 text-primary">Admin Action: Update Report</h5>
            <Form onSubmit={handleSubmit(onUpdate)}>
                <Row>
                    <Col md={4} className='mb-3'>
                        <Form.Label className='small fw-bold'>Update Status</Form.Label>
                        <Form.Select {...register("status", {required: true})}>
                            <option value='pending'>Pending</option>
                            <option value='under_investigation'>Under Investigation</option>
                            <option value='resolved'>Resolved</option>
                            <option value='closed'>Closed</option>
                        </Form.Select>
                    </Col>

                    <Col md={8}>
                        <Form.Label className='small fw-bold'>Action Taken/Notes</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            isInvalid={!!errors.action_taken}
                            {...register("action_taken", {required: "Please describe the action taken"})}
                        />
                        <Form.Control.Feedback type='invalid'>
                            {errors.action_taken?.message}
                        </Form.Control.Feedback>
                    </Col>
                </Row>
                <div className='text-end'>
                    <Button
                        type='submit'
                        variant='primary'
                        className='mt-4'
                        disabled={submitting}>
                        {submitting ? <Spinner size='sm' /> : 'Update Report'}
                    </Button>
                </div>
            </Form>
        </Card.Body>
    </Card>
  )
}

export default IncidentUpdateForm